import type { FC } from 'react';

import {
  CallDetailsParticipant,
  NewCallContainer,
} from 'features/call/call-details/components';
import type { CallDetailsParticipantInfo } from 'features/call/call-details/interfaces';
import { CustomGreeting } from 'features/custom-greeting/components';

export interface CallDetailsNewCallProps {
  caller: CallDetailsParticipantInfo;
}

export const CallDetailsNewCall: FC<CallDetailsNewCallProps> = ({ caller }) => {
  return (
    <>
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <NewCallContainer />
    </>
  );
};
